<template>
    <!-- <NavBar bgcolor="white">
        <template v-slot:title>
            <span class="nav-title">我的库藏</span>
        </template>
    </NavBar> -->
    <div>
      <!-- <div class="list">
        <span class="item active">我的藏品</span>
        <span class="item">我的预约</span>
        <span class="item">我的订单</span>
        <span class="item">我的卡劵</span>
      </div>
      <div></div> -->
    </div>
</template>

<script src="./Page.js"></script>

<style src="./Page.scss" lang="scss" scoped></style>